import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _groupBy from "lodash/groupBy";
import _mapValues from "lodash/mapValues";
import _isNil from "lodash/isNil";
import _map from "lodash/map";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
const addItem = (items, at, itemToAdd) => {
  const result = _map(items, item => _objectSpread(_objectSpread({}, item), {}, {
    lastMove: false
  }));
  result.splice(at, 0, itemToAdd);
  return result;
};
const removeItem = (items, at) => {
  const result = _map(items, item => _objectSpread(_objectSpread({}, item), {}, {
    lastMove: false
  }));
  result.splice(at, 1);
  return result;
};
const orderGroupedItems = (groupedItems, targets, _ref) => {
  let {
    destination,
    source
  } = _ref;
  const finalDestination = _isNil(destination) ? source : destination;
  const itemAdd = _objectSpread(_objectSpread({}, groupedItems[source.droppableId][source.index]), {}, {
    lastMove: true,
    target: finalDestination.droppableId
  });
  return _mapValues(_groupBy(targets, 'id'), (targetProp, id) => {
    let newItems = groupedItems[id];
    if (source.droppableId === id) {
      newItems = removeItem(newItems, source.index);
    }
    if (finalDestination.droppableId === id) {
      newItems = addItem(newItems, finalDestination.index, itemAdd);
    }
    return newItems;
  });
};
export default orderGroupedItems;